import Link from 'next/link';
import { useTranslation } from 'next-i18next';

const ToLogin = () => {
  const { t } = useTranslation();
  return (
    <div className="content">
      <div className="page-login">
        <div className="login-title">
          <div className="h1">
            <Link href="/terminal/login" passHref>
              <span>{t('login')}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToLogin;
